import { ScalarObject } from './types'

// This is a common function used in multiple places extracted out
// to avoid circular dependencies
export function classifyScalar(raw: string): ScalarObject {
  const lower = raw.toLowerCase()
  if (lower === 'true') return { kind: 'boolean', value: true }
  if (lower === 'false') return { kind: 'boolean', value: false }
  if (/^-?\d+(?:\.\d+)?$/.test(raw))
    return { kind: 'number', value: Number(raw) }
  return { kind: 'string', value: raw }
}
